import { input, Component, booleanAttribute, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-dialog-content',
  templateUrl: './dialog-content.component.html',
  styleUrl: './dialog-content.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'dialog-content',
    '[class.dialog-content_form]': 'isFormContent()',
  },
})
export class DialogContentComponent {
  isFormContent = input(false, { transform: booleanAttribute });
}
